import { FormHeader } from "@/components/form-elements/FormHeader"
import { InfoCard } from "@/components/layout/SectionCards"

export function PlaidInfoCard() {
  return (
    <InfoCard>
      <FormHeader title="Why Connect Your Bank?" />
      <ul className="flex flex-col gap-5">
        <li className="flex items-start gap-2">
          <span>
            <strong>Faster Decisions:</strong> By securely connecting your bank
            account, we can instantly review your business performance and
            accelerate the approval process.
          </span>
        </li>
        <li className="flex items-start gap-2">
          <span>
            <strong>Personalized Offers:</strong> Your funding options will be
            based on real transaction data, allowing us to provide more accurate
            and tailored offers.
          </span>
        </li>
      </ul>
    </InfoCard>
  )
}
